import { useState, useEffect } from "react";
import { Button, Box } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { formatName } from "@/utils";
import { Dealer } from "@/interfaces";
import { colors } from "@/theme";
import {
  DealerAvatar,
  DealerInfo,
  ChannelsRadioGroup,
  CoopInfoRadioItem,
} from "@/components/atoms";
import { ReactComponent as AvatarImage } from "../../../assets/DTV Logo.svg";

export type DealerDialogProps = {
  dealer?: Dealer;
  open?: boolean;
  onClose?: (channel?: string) => void;
};

const DealerDialog: React.FC<DealerDialogProps> = ({
  dealer = undefined,
  open = false,
  onClose = undefined,
}) => {
  const [channel, setChannel] = useState<string | undefined>();
  const [channels, setChannels] = useState<CoopInfoRadioItem[]>(
    (Array.isArray(dealer?.channels)
      ? dealer?.channels?.map((item) => {
          return { ...item, checked: false };
        })
      : []) as CoopInfoRadioItem[]
  );
  console.log('channels', channels);

  useEffect(() => {
    if (open) {
      document.body.classList.add("scan-dealer-page-active");
    } else {
      document.body.classList.remove("scan-dealer-page-active");
    }

    return () => {
      document.body.classList.remove("scan-dealer-page-active");
    };
  }, [open]);

  const onChange = (newValue?: string): void => {
    if (!newValue) {
      return;
    }

    setChannelChecked(channel, newValue);
    setChannel(newValue);
  };

  const setChannelChecked = (oldValue?: string, newValue?: string): void => {
    if (!newValue) {
      return;
    }

    const tmpChannels = [...channels];

    setChannelCheckedValue(tmpChannels, oldValue, false);
    setChannelCheckedValue(tmpChannels, newValue, true);

    setChannels(tmpChannels);
  };

  const setChannelCheckedValue = (
    channels: CoopInfoRadioItem[],
    channel?: string,
    checked?: boolean
  ) => {
    const idx = channels.findIndex(
      (item) => item.channel?.toLowerCase() === channel
    );
    if (idx !== -1) {
      channels[idx].checked = checked;
    }
  };

  const handleSelectButtonClick = () => {
    if (!channel) {
      return;
    }

    onClose?.(channel);
  };

  if (!open) {
    return null;
  } 

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100%",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1000,
        backgroundColor: colors.neutralGrey300,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "95%",
          height: "85%",
          padding: "40px 20px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          backgroundColor: colors.white,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "80%",
            justifyContent: "center",
            height: "100%",
            gap: "40px",
          }}
        >
          <Box>
            <AvatarImage />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <DealerInfo
                fullName={formatName(dealer?.firstName, dealer?.lastName)}
                company={dealer?.company}
                email={dealer?.email}
                textAlign="center"
              />
            </Box>

            <Box sx={{ marginTop: "24px", width: "100%" }}>
              <ChannelsRadioGroup
                items={channels}
                onChange={onChange}
                onCardClick={(channel) => onClose?.(channel)}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DealerDialog;
